<template>
    <div class="input-tags">
        <div class="field">
            <input class="tag-field" type="text" v-model="inputValue" v-bind:placeholder="placeholder" v-on:keyup.enter="checkKey" v-on:keyup.188="checkKey"/>
        </div>

        <div class="tags" v-if="tags.length > 0">
            <div v-if="tag != ''" v-for="(tag, index) in tags" v-on:dblclick="edit(index)" class="pill green inline">
                <div class="flex-center">
                    <div v-html="tag"></div>
                    <div class="flex-filler"></div>
                    <div @click="remove(index)" class="material-icons">close</div>
                </div>
                <input v-bind:name="inputName" v-bind:value="tag" type="hidden"/>
            </div>
        </div>
    </div>
</template>

<script>
    module.exports = {
        created: function () {
            this.inputName = this.name + '[]';
            this.tags = this.fields;
        },
        data:function() {
            return {
                inputValue:'',
                inputName:'tags[]',
                tags:[]
            }
        },
        props:{
            placeholder:{type:String, default:"Separate with commas"},
            name:{type:String, default:"tags"},
            fields:{type:Array, default:function () {return []}},
        },
        methods: {
            checkKey:function() {
                if (this.inputValue != "" && this.inputValue != " " && this.inputValue != ","){
                    var e = this;
                    if (this.inputValue.slice(-1) == ","){
                        this.inputValue = this.inputValue.slice(0, -1);
                    }
                    e.tags.push(e.inputValue);
                    e.inputValue = "";
                    setTimeout(function() {
                        e.$root.$setModalItemHeight();
                    },10);
                }
            },
            edit:function(index){
                this.inputValue = this.tags[index];
                this.remove(index);
                $('.tag-field').focus();

            },
            remove:function(index) {
                var e = this;
                e.$delete(e.tags,index);
                console.log(e.tags);
                setTimeout(function() {
                    e.$root.$setModalItemHeight();
                },100);
            }

        },
        mounted:function() {

        }
    }
</script>
